module.exports = __webpack_public_path__ + "media/images/countrysquared/bq-afd52688d4e44330c274c3f8c79b5e40.svg";